import React from 'react';
import {selectCurrentVariationId} from '@packages/systems/optimization/store';
import {createCurrentVariationDataAttribute} from '@packages/systems/optimization/utils';
import type {OptimizationState} from '@packages/systems/optimization/types';

/**
 * Hook that manages variation-specific attributes on the document root element.
 * It removes existing variation attributes and sets new ones based on the current variation.
 */
export const useVariationAttributes = (
  optimizationState: OptimizationState | undefined
): void => {
  React.useEffect(() => {
    if (!optimizationState) return;

    const currentVariationId = selectCurrentVariationId(optimizationState);

    // Remove existing variation attributes
    Array.from(document.documentElement.attributes).forEach((attr) => {
      if (attr.name.startsWith('data-intellimize-var-')) {
        document.documentElement.removeAttribute(attr.name);
      }
    });

    // Set new variation attribute if there's a current variation
    if (currentVariationId) {
      document.documentElement.setAttribute(
        createCurrentVariationDataAttribute(currentVariationId),
        ''
      );
    }
  }, [optimizationState]);
};
